import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home.vue')
  },
  { 
    path: '/planos/:empresa',
    name: 'planos',
    component: () => import('@/views/Planos.vue')
  },
  { 
    path: '/servicos/:empresa',
    name: 'serviços',
    component: () => import('@/views/Servicos.vue')
  },
  { 
    path: '/sobrenos',
    name: 'sobrenos',
    component: () => import('@/views/Sobre.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
